import { Canvas } from 'fabric';
import { usePlayback } from '../../playback';
import { usePlaybackFrames } from '../sync/use-playback-frames';
import { usePieceModel } from '../../model/piece-context';
import { useModelToFabric } from '../../model/sync/use-model-to-fabric';

type UseTimelineEditorBridgeReturn = {
  restoreEditingState: () => void;
};

export const useTimelineEditorBridge = (canvas: Canvas | null): UseTimelineEditorBridgeReturn => {
  const model = usePieceModel();
  const { isPlaying } = usePlayback();

  useModelToFabric(canvas, model); // the model draws onto the canvas
  return usePlaybackFrames(canvas, model, isPlaying);
};
